import React from 'react';
import InternalOrders from 'src/components/InternalOrders';
import ResponsiveWrapper from 'src/components/ResponsiveWrapper';

const ProxyInternalOrders = () => {
    return (
        <ResponsiveWrapper>
            <InternalOrders />
        </ResponsiveWrapper>
    );
};

export default ProxyInternalOrders;
